import { call, put, takeLatest } from "redux-saga/effects";
import { authActions } from "store/auth/slice";
import request from "utils/request";

function* checkAuthWorker() {
  try {
    const data = yield call(request, "/api/auth/me", {
      method: "GET",
      credentials: "include"
    });
    yield put(authActions.checkAuthSuccess({ user: data.user }));
  } catch (error) {
    yield put(authActions.checkAuthFailure(error.message));
  }
}

export function* authSaga() {
  yield takeLatest(authActions.checkAuthRequest.type, checkAuthWorker);
}
